
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { MatInput } from "@angular/material/input";
import { Observable } from "rxjs";
import { CreatePriorityAttributes } from "../../../../_models/priority.interface";
import { FullProjectHash } from "../../../../_models/project.interface";
import { ProjectService } from "../../../../_services";
import { FormModalComponent } from "../form-modal-component.class";

@Component({
  selector: "hawk-add-new-priority-modal",
  imports: [FormsModule, ReactiveFormsModule, MatInput],
  templateUrl: "./add-new-priority-modal.component.html",
  standalone: true,
  styleUrls: ["./add-new-priority-modal.component.scss"],
})
export class AddNewPriorityModalComponent extends FormModalComponent<CreatePriorityAttributes, FullProjectHash> {
  @Input() project: FullProjectHash;

  @Input() override formGroup: UntypedFormGroup;
  @Output() override closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() override newDBOutput: EventEmitter<FullProjectHash> = new EventEmitter<FullProjectHash>();

  constructor(private projectService: ProjectService) {
    super();
  }

  override formGroupToDBInput(): CreatePriorityAttributes {
    return {
      name: this.formGroup.controls["name"].value,
      color: this.formGroup.controls["color"].value,
      days: this.formGroup.controls["days"].value,
      hours: this.formGroup.controls["hours"].value,
      material_return: this.formGroup.controls["material_return"].value,
      material_shipping: this.formGroup.controls["material_shipping"].value,
      staging: this.formGroup.controls["staging"].value,
      flexible_week: this.formGroup.controls["flexible_week"].value,
      priority_idx: this.formGroup.controls["priority_idx"].value,
      sla_type: this.formGroup.controls["sla_type"].value,
      telephone_dispatching: this.formGroup.controls["telephone_dispatching"].value,
      project_id: this.formGroup.controls["project_id"].value,
    };
  }

  override getDBCallObservable(create_priority_attributes: CreatePriorityAttributes): Observable<FullProjectHash> {
    return this.projectService.createProjectPriority(create_priority_attributes.project_id, create_priority_attributes);
  }
}
